import { ActivityLogDTO, LogEntityType, LogAction, LogContextType } from 'wisestep-api';

export interface WsActivityProps {
  activity: React.ReactNode;
  leftChildren: React.ReactNode;
}

export const getAvEditAddDes = (nullArray: string[], dirtyArray: string[]) => {
  const slicedDirtyArray = dirtyArray.slice(0, 15);
  const add = nullArray.filter((element) => slicedDirtyArray.includes(element));
  const edit = slicedDirtyArray.filter((element) => !nullArray.includes(element));
  const addedDes = add.length > 0 ? `ADDED ${add.toString()}` : '';
  const editDes = edit.length > 0 ? `EDITED ${edit.toString()}` : '';
  if (add.length > 0 && edit.length > 0) {
    return `${addedDes} & ${editDes}`;
  } else {
    return `${addedDes} ${editDes}`;
  }
};

export const getAvEditAddDesUiName = (
  entityTpe: string,
  nullArray: string[],
  dirtyArray: string[]
) => {
  const addUIName: any = [];
  const editUIName: any = [];
  const slicedDirtyArray = dirtyArray.slice(0, 20);
  const add = nullArray.filter((element) => slicedDirtyArray.includes(element));
  const edit = slicedDirtyArray.filter((element) => !nullArray.includes(element));
  if (entityTpe === 'Client') {
    add.forEach((item) => {
      addUIName.push(getClientActivityUInameValue[item]);
    });
    edit.forEach((item) => {
      editUIName.push(getClientActivityUInameValue[item]);
    });
  } else if (entityTpe === 'Invoice') {
    add.forEach((item) => {
      addUIName.push(getInvoicerActivityUInameValue[item]);
    });
    edit.forEach((item) => {
      editUIName.push(getInvoicerActivityUInameValue[item]);
    });
  } else if (entityTpe === 'Lead') {
    add.forEach((item) => {
      addUIName.push(getLeadActivityUInameValue[item]);
    });
    edit.forEach((item) => {
      editUIName.push(getLeadActivityUInameValue[item]);
    });
  } else {
    add.forEach((item) => {
      addUIName.push(getPlacementActivityUInameValue[item]);
    });
    edit.forEach((item) => {
      editUIName.push(getPlacementActivityUInameValue[item]);
    });
  }
  const addedDes = addUIName.length > 0 ? `ADDED ${addUIName.toString()}` : '';
  const editDes = editUIName.length > 0 ? `EDITED ${editUIName.toString()}` : '';
  if (add.length > 0 && edit.length > 0) {
    return `${addedDes} & ${editDes}`;
  } else {
    return `${addedDes} ${editDes}`;
  }
};

export const getEditFiledForPlacementToInvoiceConverstion = (
  clientId: string,
  orgEnitiyId: string,
  newClientId: string,
  newOrgEnitiyId: string
) => {
  const res1 = clientId !== newClientId ? 'Client Name' : '';
  const res2 = orgEnitiyId !== newOrgEnitiyId ? 'Our Entity' : '';
  return (res1 + res2).length > 0 ? `EDITED ${res1} ${res2}` : '';
};

export const getConversionUIName = (entityTpe: string, dirtyArray: string[]) => {
  const addUIName: any = [];
  const slicedDirtyArray = dirtyArray.slice(0, 20);
  if (entityTpe === 'Invoice') {
    slicedDirtyArray.forEach((item) => {
      if (!(item === 'clientName' || item === 'ourEntityId')) {
        addUIName.push(getInvoicerActivityUInameValue[item]);
      }
    });
  }
  const addedDes = addUIName.length > 0 ? `ADDED ${addUIName.toString()}` : '';
  return addedDes;
};

export const getSubmissonConversionUIName = (dirtyArray: string[]) => {
  const addUIName: any = [];
  const slicedDirtyArray = dirtyArray.slice(0, 25);
  slicedDirtyArray.forEach((item) => {
    if (
      !(
        item === 'clientName' ||
        item === 'candidateName' ||
        item === 'candidateEmail' ||
        item === 'candidateContact' ||
        item === 'positionId'
      )
    ) {
      addUIName.push(getPlacementActivityUInameValue[item]);
    }
  });
  const addedDes = addUIName.length > 0 ? `ADDED ${addUIName.toString()}` : '';
  return addedDes;
};

export const activityLogDTOHelper: ActivityLogDTO = {
  id: '',
  field: '',
  entityId: '',
  parentEntitiyId: '',
  entityName: '',
  description: '',
  parentEntitiyName: '',
  action: LogAction.Add,
  entityType: LogEntityType.ClientContact,
  parentEntitiyType: LogContextType.Client,
  createdOn: new Date(),
  createdByName: '',
  workspaceId: '',
  createdBy: '',
  contextData: '',
};

const getClientActivityUInameValue = {
  parentId: 'Parent client',
  name: 'Client Name',
  firstName: 'First Name',
  lastName: 'Last Name',
  position: 'Position',
  emailAddress: 'Email Address',
  phoneNumber: 'Phone Number',
  locationName: 'Branch/Location Name',
  physicalAddress: 'Physical Address',
  linkedinProfile: 'Linkedin Profile',
  supervisorEmailAddress: 'Supervisor Email Address',
  legalName: 'Legal Name',
  businessUnit: 'Business Unit',
  industry: 'Industry Type',
  source: 'Source',
  website: 'Website',
  timezone: 'Time Zone',
  invoiceCode: 'Invoice Code',
  branch: 'Branch Name',
  location: 'Location',
  address: 'Address',
  description: 'Description',
  legalIdentifierId: 'Legal Identifier Type *',
  value: 'Legal Identifier Value *',
  bankName: 'Bank Name *',
  branchName: 'Branch Name *',
  bankCode: 'Bank Code *',
  bankAccountNumber: 'Bank Account Number *',
  currencyId: 'Currency *',
  iban: 'International Bank Number',
  swiftCode: 'Swift Code',
  isDefault: 'Is Default',
  Name: 'Organisation Name',
  Country: 'Country',
  Business_Name: 'Business Unit',
  fileCategoryType: 'Select File Category to upload a file',
  contractType: 'Contract Type',
  clientContact: 'Client Contact Name',
  startDate: 'Contract Start Date',
  endDate: 'Contract End Date',
  feeArrangementLevel: 'Position Category',
  employmentGuarantee: 'Employment Guarantee Period',
  feeType: 'Service Fees',
};

const getPlacementActivityUInameValue = {
  clientName: 'Client Name',
  ourEntityId: 'Organisation Entity',
  candidateName: 'Candidate Name *',
  candidateLocation: 'Candidate Location *',
  candidateEmail: 'Candidate Email *',
  candidateContact: 'Candidate Contact',
  offerDate: 'Offer Date',
  joiningDate: 'Joining Date',
  bankName: 'Bank',
  transcationDate: 'Transcation Date',
  paymentReference: 'Payment Reference',
  currencyType: 'Currency',
  exchangeRate: 'Exchange Rate',
  transcationAmount: 'Amount',
  transactionComment: 'Transcation Comments',
  docName: 'Document Name',
  docDes: 'Document Description',
  businessUnit: 'Business Unit',
  placementStatusId: 'Placement Status Name',
  placementOrigin: 'Placement Origin',
  accountManager: 'Account Manager',
  teamLeader: 'Team Leader',
  recruiterOne: 'Recruiter 1',
  recruiterTwo: 'Recruiter 2',
  deliveryManager: 'Delivery Manager',
  deliveryLead: 'Delivery Lead',
  clientRecruiterOne: 'Client Contact 1',
  clientRecruiterTwo: 'Client Contact 2',
  comments: 'Comments',
  fileCategoryType: 'Document Type',
  documentName: 'Document Name',
  validFrom: 'Validity From',
  validTill: 'Validity Till',
  currencyId: 'Currency',
  compensationAmount: 'Compensation Amount',
  period: 'Period',
  arrangementType: 'Fee Arrangement Type',
  feeArrangementAmount: 'Arrangement Amount / Percentage',
  commissionValue: 'Commission Value',
  employmentGuaranteeDays: 'Employment Guarantee Days',
  employmentGuaranteeEndDate: 'Employment Guarantee End Date',
  title: 'Job Title',
  locations: 'Job Location',
  description: 'Job Description',
  team: 'Team',
  feeArrangementId: 'Fee Arrangement',
  positionTitle: 'Job',
};

const getInvoicerActivityUInameValue = {
  clientName: 'Client Name',
  ourEntityId: 'Our Entity',
  clientInvoiceTypeId: 'Invoice Type',
  invoiceCode: 'Invoice Number',
  raisedDate: 'Invoice Date',
  dueDate: 'Due Date',
  ourEntityBankId: 'Bank Information',
  legalIdentifierValue: 'Legal Identifiers',
  subTotal: 'Sub Total',
  totalBeforeTaxation: 'Total Before Taxation',
  taxations: 'Invoice Taxation',
  adjustments: 'Additional Taxation',
  total: 'Total',
  amountInWord: 'Amount In Words',
  termsAndConditions: 'Terms and Conditions',
  description: 'Description/Comments',
  bankName: 'Bank',
  transcationDate: 'Transcation Date',
  paymentReference: 'Payment Reference',
  currencyType: 'Currency',
  exchangeRate: 'Exchange Rate',
  transcationAmount: 'Amount',
  transactionComment: 'Transcation Comments',
  docName: 'Document Name',
  docDes: 'Document Description',
};

export const getLeadActivityUInameValue = {
  leadName: 'Lead Name',
  status: 'Status',
  leadOwnerId: 'Lead Owner',
  source: 'Source',
  companyName: 'Client',
  clientRecruiter: 'Client Contact',
  businessUnitsInfo: 'Business Unit',
  linkedinUrl: 'LinkedIn URL',
  tags: 'Tags',
  description: 'Description',
  organisationEntityId: 'Organization Entity',
  clientId: 'Client ID',
  clientContactId: 'Client Contact ID',
};
